export default {
  allUsers: 'Všetci používatelia',
  zeroUsers: 'Vybraných je 0 používateľov',
  users: 'používatelia',
};
